var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "#31424a",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 7 L 0 9.9121094 C 6.708 15.709109 20.532062 27.656578 21.664062 28.642578 C 23.074063 29.869578 24.466 30.001953 25 30.001953 C 25.534 30.001953 26.926937 29.870531 28.335938 28.644531 C 29.425937 27.695531 42.784 16.033422 50 9.7324219 L 50 7 L 0 7 z M 50 12.382812 C 42.588 18.853813 30.673484 29.255437 29.646484 30.148438 C 27.729484 31.817438 25.758 31.998047 25 31.998047 C 24.242 31.998047 22.270516 31.817484 20.353516 30.146484 C 19.290516 29.222484 7.044 18.638781 0 12.550781 L 0 43 L 50 43 L 50 12.382812 z",
    fill: "#31424a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.09e16f7829ae7fd1673477b11b650f7a.svg";
export { ForwardRef as ReactComponent };